/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import "./Nav.css";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteModel from "../../../Components/DeleteModel";
import { clearAllLocalStorage } from "../../../Utiles/localStorage";
import { MessageCircle, User, LogOut, ChevronDown } from "lucide-react";
import { useGetUserByIdQuery } from "../../../redux/api/User/UserApi";
import useUser from "../../../hooks/useUser";
import { useLayout } from "../../../context/LayoutContext";


const MainNav = () => {
  const [logoutShow, setLogoutShow] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { toggleMobileSidebar } = useLayout();
  const { userId, decoded } = useUser();

  const handleModelClose = () => setLogoutShow(false);
  const { data: userData, } = useGetUserByIdQuery(userId, {
    skip: !userId,
  });

  const user = userData?.data;

  const handleLogout = () => {
    clearAllLocalStorage();
    navigate("/login");
    window.location.reload();
  };

  // Improved header styles
  const headerStyles = {
    position: "sticky",
    top: "0",
    zIndex: 1000,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderBottom: "1px solid var(--border-color)",
    backdropFilter: "blur(12px)",
    padding: "0 16px",
    height: "64px",
    display: "flex",
    alignItems: "center",
  };

  // Simple page title mapping
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes("/dashboard")) return "Dashboard";
    if (path.includes("/contacts")) return "Contacts";
    if (path.includes("/campaigns")) return "Campaigns";
    if (path.includes("/templates")) return "Templates";
    if (path.includes("/bots")) return "Bot Builder";
    if (path.includes("/whatsapp")) return "WhatsApp Settings";
    if (path.includes("/billing")) return "Billing";
    if (path.includes("/settings")) return "Settings";
    return "Menu";
  };

  return (
    <>
      <div style={headerStyles} className="main-header-premium">
        <Container fluid>
          <Row className="align-items-center justify-content-between g-0">
            <Col xs="auto" className="d-flex align-items-center gap-2">
              {/* Hamburger for Mobile */}
              <div className="mobile-only">
                <button
                  className="border-0 bg-transparent p-2 rounded-3 hover-effect d-flex align-items-center justify-content-center"
                  onClick={toggleMobileSidebar}
                  style={{ color: 'var(--text-primary)' }}
                >
                  <AiOutlineMenu size={22} />
                </button>
              </div>

              {/* Logo (Mobile Only) / Title (Desktop Only) */}
              <div
                className="d-flex align-items-center gap-2 cursor-pointer ms-1"
                onClick={() => navigate("/admin/dashboard")}
              >
                <div className="mobile-only">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center justify-content-center"
                      style={{
                        width: '32px',
                        height: '32px',
                        background: 'var(--color-primary)',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)'
                      }}>
                      <MessageCircle size={18} color="white" />
                    </div>
                    <span className="fw-bold" style={{ fontSize: '18px', color: 'var(--text-primary)', letterSpacing: '-0.5px' }}>
                      Chatfuse
                    </span>
                  </div>
                </div>

                <div className="desktop-only text-truncate" style={{ maxWidth: '300px' }}>
                  <h1 className="fw-bold mb-0" style={{ fontSize: '18px', color: 'var(--text-primary)', letterSpacing: '-0.2px' }}>
                    {getPageTitle()}
                  </h1>
                </div>
              </div>
            </Col>

            <Col xs="auto" className="d-flex align-items-center gap-3">
              <Dropdown align="end">
                <Dropdown.Toggle
                  as="div"
                  className="cursor-pointer"
                  style={{ cursor: 'pointer' }}
                  noCaret
                >
                  <div className="d-flex align-items-center gap-2 p-1 pe-3 rounded-pill hover-effect border bg-white shadow-sm">
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        background: `linear-gradient(135deg, var(--color-primary), #059669)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      <User size={16} />
                    </div>
                    <div className="d-none d-md-block text-start" style={{ lineHeight: '1.2' }}>
                      <div className="small fw-bold text-dark">{user?.name?.split(' ')[0] || 'User'}</div>
                      <div className="text-muted" style={{ fontSize: '10px' }}>{decoded?.role === 'admin' ? 'Administrator' : 'Agent'}</div>
                    </div>
                    <ChevronDown size={14} className="text-muted opacity-75 ms-1" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow-lg border-0 mt-2 p-2 rounded-4" style={{ minWidth: '220px' }}>
                  <div className="px-3 py-2 mb-2 border-bottom">
                    <div className="fw-bold text-dark">{user?.name || "User"}</div>
                    <div className="small text-muted text-truncate">{user?.email}</div>
                  </div>

                  <Dropdown.Item
                    className="rounded-3 py-2 d-flex align-items-center gap-2"
                    onClick={() => navigate("/admin/settings")}
                  >
                    <User size={16} />
                    <span>Profile Settings</span>
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Item
                    className="rounded-3 py-2 d-flex align-items-center gap-2 text-danger"
                    onClick={() => setLogoutShow(true)}
                  >
                    <LogOut size={16} />
                    <span>Sign Out</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Container>
      </div>

      <style jsx>{`
       .dropdown-toggle::after {
        display: none !important;
       }

        .hover-effect {
          transition: all 0.2s ease;
        }
        .hover-effect:hover {
          background-color: rgba(0, 0, 0, 0.05) !important;
        }
        .main-header-premium {
          padding-left: 240px; /* Offset for sidebar */
        }
        @media (max-width: 1023px) {
          .main-header-premium {
            padding-left: 0;
          }
        }
      `}</style>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Are you sure you want to sign out?"
        DELETETITLE="Sign Out"
      />
    </>
  );
};

export default MainNav;
